export default __webpack_public_path__ + "static/media/3B 1.8c3d36d3.jpg";